(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.price-scarcity-badge__text').forEach(function (el) {
    var quantity = Math.floor(Math.random() * 15) + 1;
    el.textContent = 'Tükeniyor! Son ' + quantity + ' adet';
  });
  } catch(e) { console.error(e); }
})();

})();
